import { elements, modifiers } from '#components/generics/js/styles.js'
import listener from '@mailobj-browser/front/js/events/listeners/listener.js'
import passive from '@mailobj-browser/front/js/events/options/passive.js'
import input from '@mailobj-browser/front/js/events/types/input.js'
import all from '@mailobj-browser/front/js/selectors/all.js'
import closest from '@mailobj-browser/front/js/selectors/closest.js'
import object from '@mailobj-browser/front/js/utils/object.js'
import * as utilities from '#utilities/js/styles.js'

const onInput = object(listener, {
  type: input,
  passive,
  task: (
    checkbox
  ) => {
    const fields = closest(`.${elements.new_fields}`, checkbox)
    const inputsTime = all(`.${modifiers.new_fieldset_pattern.new_pattern_time_select}`, fields)

    for (const inputTime of inputsTime) {
      const stackRow = closest(`.${elements.new_fields}`, inputTime)

      if (inputTime.classList.contains(utilities.modifiers.display.none)) {
        stackRow.classList.add(modifiers.stack.small)
        stackRow.classList.remove(modifiers.stack.noGap)
      } else {
        stackRow.classList.remove(modifiers.stack.small)
        stackRow.classList.add(modifiers.stack.noGap)
      }
      inputTime.classList.toggle(utilities.modifiers.display.none)
    }

  }
})

export default (checkbox) => {
  onInput.listen(checkbox)
}
